import { createTopNLeadsSearchRequestDto } from "app/pages/sales-intelligence/modules/leads-search";
import type { FetchTopNDomainsParams } from "app/pages/sales-intelligence/modules/leads-search/store/types";
import { getLeadDomainFromRow } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { is } from "app/pages/sales-intelligence/utils/type-guards";
import queryClient from "single-spa/react-app/query-client";

import { advancedSearchQueryKeyFactory } from "../queryKeyFactory";

export const fetchTopNLeadsDomains = async <P extends Partial<FetchTopNDomainsParams>>({
    leadsType,
    domainsCount,
    dto,
}: P): Promise<readonly string[] | undefined> => {
    if (!domainsCount || !leadsType || !dto) {
        return;
    }

    const updatedDto = createTopNLeadsSearchRequestDto(dto, domainsCount);

    const searchResults = await queryClient.fetchQuery({
        queryKey: advancedSearchQueryKeyFactory.tableData(leadsType, updatedDto),
        queryFn: ({ signal }) =>
            salesApiService.advancedSearchPage[leadsType].fetchSearchResults(updatedDto, {
                cancellation: signal,
            }),
    });

    if (is.undefined(searchResults)) {
        return [];
    }

    return searchResults.rows.map(getLeadDomainFromRow);
};
